'use strict';

/*
---------------------------------------
Loader
---------------------------------------
*/
import {showLoading} from './backend/common';

window.addEventListener('beforeunload', function (e) {
    if ($('.js-csv-download-btn:disabled').length) {
        setTimeout(function () {
            $('.js-csv-download-btn:disabled').prop('disabled', false);
        }, 1000);

        return true;
    }
    if ($('#exportOrderCSVModal').hasClass('show')) {
        return true;
    }
    showLoading();
});

$(window).on('load', function () {
    let loadDingScreen = document.getElementById("loading");
    if (loadDingScreen) {
        $(loadDingScreen).hide();
    }
});

$(document).ready(function () {
    let loadDingScreen = document.getElementById("loading");
    if (loadDingScreen && ($(loadDingScreen).is(':visible') || $(loadDingScreen).is(':hidden'))) {
        loadDingScreen.remove();
    }
})
